// extracted by mini-css-extract-plugin
module.exports =  {"switch-wrapper":"stage_settings__switch-wrapper___B1eo6","switchWrapper":"stage_settings__switch-wrapper___B1eo6"};